import PropTypes from "prop-types";
import { CATEGORIES } from "../../../domain/influencerService";
import {
  Box,
  Card,
  Chip,
  PencilIcon,
  PersonalizeIcon,
  TuneIcon,
} from "../../../themeV2";
import { SERVICE_TYPE_ORDER, SERVICE_TYPES } from "./serviceTypes";

const categoryIcons = {
  [CATEGORIES.QUOTE]: PersonalizeIcon,
  [CATEGORIES.DOODLE]: PencilIcon,
  [CATEGORIES.CUSTOM]: TuneIcon,
};

export default function ServiceTypeChooser({ headingId, onChoose }) {
  return (
    <Box direction="column" gap={3} role="group" aria-labelledby={headingId}>
      {SERVICE_TYPE_ORDER.map((category) => {
        const { noun, blurb, isAdvanced } = SERVICE_TYPES[category];
        const Icon = categoryIcons[category];

        return (
          <Card.Root
            key={category}
            variant="outlined"
            clickable
            onClick={() => onChoose(category)}
          >
            <Card.Header
              avatar={
                <span aria-hidden="true">
                  <Icon />
                </span>
              }
              title={noun}
              subtitle={blurb}
              action={
                isAdvanced ? (
                  <Chip label="Advanced" size="sm" variant="assist" />
                ) : null
              }
            />
          </Card.Root>
        );
      })}
    </Box>
  );
}

ServiceTypeChooser.propTypes = {
  headingId: PropTypes.string.isRequired,
  onChoose: PropTypes.func.isRequired,
};
